<template>
    <div id="filter-sidebar" class="col-md-3 p-0 body_content_left_col">
        <div class="gdc-filter-wrapper d-flex flex-column" data-inc="GDC - Filters">
            <div class="automation-search-wrapper order-1 order-md-0 search-wrapper">
                <autocomplete
                    :suggestions="this.slotGames"
                    v-model="searchTerm"
                    :placeholder="searchPlaceholderText"
                ></autocomplete>
            </div>
            <div class="order-0 order-md-1 gdc-filter__attributes-controls clearfix">
                <button
                    type="button"
                    class="btn filter-btn"
                    aria-haspopup="true"
                    aria-expanded="false"
                    @click="isActive = true"
                >
                    <img class="lazyload slot-games-filter-icon" :data-src="filterIcon">
                    <span>{{ filterLabelText.toUpperCase() }}</span>
                    <span class="d-inline d-md-none" v-show="activeFilters.length > 0">
                        ({{ activeFilters.length }})
                    </span>
                </button>
                <div class="label">
                    {{ filterLabelText.toUpperCase() }}
                </div>
                <div class="d-none d-md-block text-center">
                    <button
                        class="btn filter-clearall-btn gdc-filter-reset-btn"
                        @click="clearFilters()"
                        v-show="activeFilters.length > 0"
                    >
                        <span>{{ clearLabelText }}</span>
                    </button>
                </div>
            </div>
            <div class="d-none d-md-block order-2 order-md-2 selected-filters pt-3">
                <ul class="p-0">
                    <li
                        v-for="filterAttribute in activeFilters"
                        :key="filterAttribute.id"
                        @click="toggleFilter(filterAttribute)"
                    >
                        <span>{{ filterAttribute.name }}</span>
                        <span class="float-right">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 16 16"
                                 style="margin: -1px 0 0 1px;"><path fill="#fff"
                                                                     d="M 15.96875 14.019531 L 9.847656 7.957031 L 15.90625 1.839844 L 14.019531 -0.03125 L 7.960938 6.089844 L 1.84375 0.03125 L -0.03125 1.902344 L 6.09375 7.972656 L 0.03125 14.097656 L 1.902344 15.96875 L 7.976562 9.839844 L 14.097656 15.90625 Z M 15.96875 14.019531"/></svg>
                        </span>
                    </li>
                </ul>
            </div>
            <div class="progressive-jackpots-container order-3 order-md-3 py-3">
                <div class="d-flex flex-row align-items-center">
                    <label class="progressive-jackpots-label mr-auto mb-0">
                        {{ progressiveLabelText }}:</label
                    >
                    <switch-button
                        :isEnabled="progressiveJackpots"
                        @toggle="toggleProgressive"
                    ></switch-button>
                </div>
            </div>
            <hr/>
            <div
                class="dropdown-menu gdc-filter clearfix order-4 order-md-4"
                :class="{ 'is-active': isActive }"
                id="filters-dropdown"
            >
                <div class="d-md-none d-flex justify-content-between bg-white mobile-header">
                    <div>
                        <img class="lazyload slot-games-filter-icon" :data-src="filterIcon">
                        {{ filterLabelText }}
                    </div>
                    <div class="close-div"
                         @click="isActive = false"
                    >
                        {{ closeLabelText }}
                        <svg class="ml-1 closeTooltip" xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="24"
                             height="24" preserveAspectRatio="xMidYMid meet" viewBox="0 0 50 50">
                            <path d="M37.304 11.282l1.414 1.414l-26.022 26.02l-1.414-1.413z" fill="#d23b42"/>
                            <path d="M12.696 11.282l26.022 26.02l-1.414 1.415l-26.022-26.02z" fill="#d23b42"/>
                        </svg>
                    </div>
                </div>
                <div class="gdc-filter__dropdown-panel__scrollable" style="height: auto">
                    <div
                        v-for="filter in filters"
                        :key="filter.id"
                        class="filter_box gdc-filter__attribute"
                        :class="filter.label | labelToClass"
                        role="group"
                    >
                        <div class="gdc-filter__dropdown-panel">
                            <h3
                                class="mx-3 m-md-0 pb-md-2"
                                data-toggle="collapse"
                                :data-target="'#label_' + filter.id"
                                aria-expanded="false"
                            >
                                {{ filter.label }}
                                <span class="icon d-inline d-md-none float-right">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 17 17"><g
                                        transform="translate(17,17) rotate(180)"><path fill="#979797"
                                                                                       d="M 0 5.191406 L 2.003906 3.1875 L 8.503906 9.800781 L 14.996094 3.1875 L 17 5.191406 L 8.503906 13.8125 Z M 0 5.191406"/></g></svg>
                                </span>
                            </h3>
                            <ul
                                class="gdc-filter__attributes-list ml-0 p-0 mr-3 mr-md-0 collapse"
                                :id="'label_' + filter.id"
                                data-parent="#filters-dropdown"
                            >
                                <li
                                    class="mx-3 m-md-0 p-0"
                                    v-for="filterAttribute in filter.attributes"
                                    :key="filterAttribute.id"
                                    @click="toggleFilter(filterAttribute)"
                                >
                                    <span
                                        :data-attr-id="filterAttribute.id"
                                        class="d-flex mt-1 align-items-center gdc-filter__attribute-btn"
                                        :class="{
                                            'gdc-filter__attribute-btn--disabled':
                                                filterAttribute.is_disabled,
                                        }"
                                    >
                                        <span class="gdc-filter__attribute-btn__checkbox mr-2 overflow-hidden">
                                            <span v-show="filterAttribute.is_active">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                                                     viewBox="0 0 16 16" style="margin-top: -15px"><path fill="#fff"
                                                                                                         d="M 6 14.023438 L 0 8.265625 L 1.859375 6.351562 L 5.964844 10.265625 L 14.105469 1.976562 L 16 3.855469 Z M 6 14.023438"/></svg>
                                            </span>
                                        </span>
                                        <span
                                            class="gdc-filter__attribute-btn__label"
                                            :class="{ bold: filterAttribute.is_active }"
                                        >
                                            {{ filterAttribute.name }}
                                        </span>
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <hr>
                    </div>
                </div>
                <div class="d-flex justify-content-center align-items-center d-block d-md-none pt-5">
                    <div class="btn clear-btn"
                         @click="clearFilters()"
                    >
                        {{ clearLabelText }}
                    </div>
                    <div class="btn save-btn"
                         @click="isActive = false"
                    >
                        {{ saveLabelText.toUpperCase() }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        initialFilters: Array,
        slotGames: Array,
        filterIcon: String,
    },
    data() {
        return {
            filters: this.initialFilters,
            searchTerm: '',
            isActive: false,
            progressiveJackpots: false,
        };
    },
    created: function () {
        this.filters = this.filters.map((filter) => {
            filter.attributes = filter.attributes.sort(function (a, b) {
                return a.order - b.order
            });

            if (filter.id === 49 | filter.id === 53) {
                filter.attributes = filter.attributes.sort(function (a, b) {
                    a = a.name;
                    b = b.name;

                    if (startsWithNumber(a) || startsWithNumber(b)) {
                        return Number(a) || Number(b);
                    }
                    function startsWithNumber(str) {
                        return /^\d/.test(str);
                    }

                    if (a < b) {return -1;}
                    if (a > b) {return 1;}
                    return 0;
                });
                // filter.attributes = filter.attributes.sort(function (a, b) {
                //     a = a.name;
                //     b = b.name;
                //     if(typeof a === 'number' && typeof b === 'string'){
                //         console.log('1', 1);
                //         console.log('a', a);
                //         console.log('b', b);
                //         console.log('--------------');
                //         return -1;
                //     };
                //     if(typeof a === 'string' && typeof b === 'number'){
                //         console.log('2', 2);
                //         console.log('a', a);
                //         console.log('b', b);
                //         console.log('--------------');
                //         return 1;
                //     };
                //     if(typeof a === 'string' && typeof b === 'string'){
                //         console.log('3', 3);
                //         console.log('a', a);
                //         console.log('b', b);
                //         console.log('--------------');
                //         return a.charCodeAt(0) - b.charCodeAt(0);
                //     };
                //     return a - b;
                // });
                filter.attributes.forEach((attr) => {
                    attr.is_active = false;
                    attr.filter_id = filter.id;
                    attr.is_disabled = this.filteredSlotGames.every(
                        (slotGame) => {
                            if (slotGame.game.slot_themes !== "undefined") {
                                return !slotGame.game.slot_themes.includes(attr.attribute_type_id);
                            } else {
                                return true;
                            }
                        }
                    );
                });
            } else if (filter.id === 48 | filter.id === 52) {
                //software
                filter.attributes.forEach((attr) => {
                    attr.is_active = false;
                    attr.filter_id = filter.id;
                    attr.is_disabled = this.filteredSlotGames.every(
                        (slotGame) => {
                            if (slotGame.game.software_id !== "undefined") {
                                return slotGame.game.software_id != attr.attribute_type_id;
                            } else {
                                return true;
                            }
                        }
                    );
                });
            }
            else {
                filter.attributes.forEach((attr) => {
                    attr.is_active = false;
                    attr.filter_id = filter.id;
                    attr.is_disabled = this.filteredSlotGames.every(
                        (slotGame) => {
                            let result = slotGame.game.attributes.find((attribute) => attribute.attribute_type_id == attr.attribute_type_id)
                            if (typeof result !== "undefined") {
                                if (result.value != attr.attribute_value) {
                                    return true;
                                } else {
                                    return false;
                                }
                            } else {
                                return true;
                            }
                        }
                    );
                });
            }

            filter.attributes = filter.attributes.filter((item) => item.is_disabled == false);
            return filter;
        });
    },
    computed: {
        activeFilters() {
            return this.filters
                .map((filter) => filter.attributes.filter((attr) => attr.is_active))
                .flat();
        },
        filteredSlotGames() {
            return this.slotGames.filter((slotGame) => {
                let active = [];

                if (this.progressiveJackpots) {
                    if (this.activeFilters.length > 0) {
                        active = this.activeFilters.map(
                            (filter) => {
                                if (filter.filter_id === 49 | filter.filter_id === 53) {
                                    //themes
                                    if (slotGame.game.slot_themes !== "undefined") {
                                        return slotGame.game.slot_themes.includes(filter.attribute_type_id) && this.getAttributeValue(slotGame, 184) === "1";
                                    } else {
                                        return false;
                                    }
                                } else if (filter.filter_id === 48 | filter.filter_id === 52) {
                                    //software
                                    return slotGame.game.software_id == filter.attribute_type_id && this.getAttributeValue(slotGame, 184) === "1";
                                } else {
                                    let result = slotGame.game.attributes.find((attribute) => attribute.attribute_type_id == filter.attribute_type_id)
                                    if (typeof result !== "undefined") {
                                        if (result.value == filter.attribute_value && this.getAttributeValue(slotGame, 184) === "1") {
                                            return true;
                                        } else {
                                            return false;
                                        }
                                    } else {
                                        return false;
                                    }
                                }
                            }
                        );
                    } else {
                        active.push(
                            this.getAttributeValue(slotGame, 184) === "1" ? true : false
                        );
                    }
                } else {
                    active = this.activeFilters.map(
                        (filter) => {
                            if (filter.filter_id === 49 | filter.filter_id === 53) {
                                //themes
                                if (slotGame.game.slot_themes !== "undefined") {
                                    return slotGame.game.slot_themes.includes(filter.attribute_type_id);
                                } else {
                                    return false;
                                }
                            } else if (filter.filter_id === 48 | filter.filter_id === 52) {
                                //software
                                return slotGame.game.software_id == filter.attribute_type_id;
                            } else {
                                let result = slotGame.game.attributes.find((attribute) => attribute.attribute_type_id == filter.attribute_type_id)
                                if (typeof result !== "undefined") {
                                    if (result.value == filter.attribute_value) {
                                        return true;
                                    } else {
                                        return false;
                                    }
                                } else {
                                    return false;
                                }
                            }
                        }
                    );
                }
                let hasFilters = active.every((value) => value === true);
                let hasSearch =
                    this.searchTerm === ''
                        ? true
                        : slotGame.title.toLowerCase().includes(this.searchTerm.toLowerCase());

                return hasFilters && hasSearch;
            });
        },
        clearLabelText() {
            return window.translations.slotGameFilters.clear_label || 'CLEAR ALL';
        },
        searchLabelText() {
            return window.translations.slotGameFilters.search || 'Search';
        },
        searchPlaceholderText() {
            return window.translations.slotGameFilters.search_placeholder || 'Search slot games...';
        },
        filterLabelText() {
            return window.translations.slotGameFilters.filter_label || 'Filter';
        },
        progressiveLabelText() {
            return window.translations.slotGameFilters.progressive_label || 'Progressive Jackpot';
        },
        closeLabelText() {
            return window.translations.slotGameFilters.close_label || 'Close';
        },
        resetLabelText() {
            return window.translations.slotGameFilters.reset_label || 'Reset';
        },
        saveLabelText() {
            return window.translations.slotGameFilters.save_label || 'Save';
        },
    },
    watch: {
        initialFilters(val) {
            this.filters = val;
        },
        searchTerm(val) {
            this.disableFilters();
            this.$emit('input', this.filteredSlotGames);
        },
    },
    methods: {
        disableFilters() {
            this.filters = this.filters.map((filter) => {
                if (filter.id === 49 | filter.id === 53) {
                    //themes
                    filter.attributes.forEach((attr) => {
                        attr.is_disabled = this.filteredSlotGames.every(
                            (slotGame) => {
                                if (slotGame.game.slot_themes !== "undefined") {
                                    return !slotGame.game.slot_themes.includes(attr.attribute_type_id);
                                } else {
                                    return true;
                                }
                            }
                        );
                    });
                } else if (filter.id === 48 | filter.id === 52) {
                    //software
                    filter.attributes.forEach((attr) => {
                        attr.is_disabled = this.filteredSlotGames.every(
                            (slotGame) => {
                                if (slotGame.game.software_id !== "undefined") {
                                    return slotGame.game.software_id != attr.attribute_type_id;
                                } else {
                                    return true;
                                }
                            }
                        );
                    });
                } else {
                    filter.attributes.forEach((attr) => {
                        attr.is_disabled = this.filteredSlotGames.every(
                            (slotGame) => {
                                let result = slotGame.game.attributes.find((attribute) => attribute.attribute_type_id == attr.attribute_type_id)
                                if (typeof result !== "undefined") {
                                    if (result.value != attr.attribute_value) {
                                        return true;
                                    } else {
                                        return false;
                                    }
                                } else {
                                    return true;
                                }
                            }
                        );
                    });
                }

                return filter;
            });
        },
        toggleFilter(filterAttribute) {
            if (filterAttribute.is_disabled) {
                return;
            }

            filterAttribute.is_active = !filterAttribute.is_active;
            this.disableFilters();
            this.$emit('input', this.filteredSlotGames);
            this.disableFilters();
        },
        clearFilters() {
            this.filters = this.filters.map((filter) => {
                filter.attributes.forEach((attr) => (attr.is_active = false));

                return filter;
            });

            this.disableFilters();
            this.$emit('input', this.filteredSlotGames);
            this.disableFilters();
        },
        toggleProgressive(state) {
            this.progressiveJackpots = state;

            this.disableFilters();
            this.$emit('input', this.filteredSlotGames);
            this.disableFilters();
        },
        getAttributeValue(slotGame, attributeId) {
            let param = slotGame.game.attributes.find((attribute) => attribute.attribute_type_id == attributeId);
            if (typeof param === "undefined") {
                param = {value: 0};
            } else {
                if (param.value === "undefined") {
                    param.value = 0;
                }
            }
            return param.value;
        }
    },
    filters: {
        labelToClass(label) {
            if (!label) {
                return '';
            }

            return label.replace(' ', '_').toLowerCase();
        },
    },
};
</script>
